var version = {
    "name":      "dativery",
    "buildDateCode": "20260903-133451",
    "buildDate": "Thu Sep 03 2026 13:34:51 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260903-133451",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;